import { GLOBAL_LOADER_STEP } from '@client/enums';

import { cloneMenuOptions, cloneViaCampaignManager } from './clone-campaign-manager';
import { cloneEditViewOptions, cloneViaEditView } from './clone-edit-view';
import { cloningCampaign } from './cloning-campaign';

let cloneSteps = [
  cloningCampaign,
  cloneViaCampaignManager,
  cloneMenuOptions,
  cloneViaEditView,
  GLOBAL_LOADER_STEP,
  cloneEditViewOptions
];

cloneSteps[4] = {
  ...cloneSteps[4],
  popover: {
    ...cloneSteps[4].popover,
    title: 'Loading campaign...'
  }
};

export const CLONE_STEPS = cloneSteps;
